import { MapContainer, TileLayer, CircleMarker, Tooltip } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { fmt } from "../../lib/api";
import { netType } from "../../lib/reports";
import { testProviderLabel } from "../../lib/servers";
import { HeatLayer, HeatLegend, speedColor } from "../UserHeatMap";


export const RepHeatMap = ({ tests }) => {
  const pts = tests.filter((t) => t.location?.lat != null);
  const center = pts.length ? [pts[0].location.lat, pts[0].location.lon] : [-29, 25];
  return (
    <div className="relative h-[480px]" data-testid="rep-heatmap">
      <MapContainer key={`${pts.length}-${pts[0]?.id}`} center={center} zoom={pts.length ? 6 : 5} className="h-full w-full" scrollWheelZoom>
        <TileLayer className="dark-tiles" url="https://tile.openstreetmap.org/{z}/{x}/{y}.png" attribution="&copy; OpenStreetMap" />
        <HeatLayer pts={pts} radius={28} />
        {pts.map((t) => (
          <CircleMarker key={t.id} center={[t.location.lat, t.location.lon]} radius={5}
            pathOptions={{ color: "#fff", weight: 1.5, fillColor: speedColor(t.download_mbps), fillOpacity: 1 }}>
            <Tooltip direction="top" offset={[0, -10]}>
              <div className="font-mono text-[11px] leading-relaxed" data-testid={`heatmap-tooltip-${t.id}`}>
                <b>{t.rep_name}</b> · {t.team}<br />
                {new Date(t.created_at).toLocaleString()}<br />
                {t.location.city || "—"} ({t.location.source})<br />
                ↓ {fmt(t.download_mbps)} · ↑ {fmt(t.upload_mbps)} Mbps<br />
                Ping {fmt(t.ping_ms, 0)}ms · Jitter {fmt(t.jitter_ms, 0)}ms<br />
                {t.isp || "Unknown"} · {netType(t)}<br />
                Tested via {testProviderLabel(t)}
                {t.issues.map((i) => <div key={i} style={{ color: "#FF3B30" }}>{i}</div>)}
              </div>
            </Tooltip>
          </CircleMarker>
        ))}
      </MapContainer>
      <HeatLegend className="absolute bottom-3 left-3 w-56 z-[500] bg-[#121212]/90 border border-white/10 px-3 py-2" />
      {!pts.length && <div className="absolute inset-0 z-[400] flex items-center justify-center text-xs text-neutral-500">No located tests for this selection.</div>}
    </div>
  );
};
